import {LMap, LTileLayer, LMarker} from 'vue2-leaflet'
import {OpenStreetMapProvider} from 'leaflet-geosearch';
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import FormService from "../../services/FormService";
import SelectPicker from "../../components/SelectPicker";
import FormInput from "../../components/FormInput";

export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        vSelect,
        SelectPicker, FormInput},
    data() {
        return {
            isLoading: true,
            center: {lat: 41.311081, lng: 69.240562},
            markerLatLng: {lat: 41.311081, lng: 69.240562},
            zoom: 15,
            url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            bounds: null,
            locations: [],
            form: new FormService({
		code: null,
                location_id: null,
                name: '',
                name_uz: '',
                name_en: '',
                locality: '',
                phone: '',
                work_schedule: '',
                lat: '',
                lng: '',
                landmark: '',
                type: '',
                alias: '',
                address: '',
            }),
            id: null,
            address: '',
            provider: null, // geo search provider for leaflet-geosearch package
            geoZones: [],
            geoZone: null,
        }
    },
    created() {
        let id = this.$route.params.id;
        if (id) {
            this.id = id;
            this.getStation();
        }
        this.getLocations();

        this.provider = new OpenStreetMapProvider();
    },
    mounted() {
        // the line below is intended to resolve this Vue2Leaflet package issue
        // https://github.com/vue-leaflet/Vue2Leaflet/issues/96#issuecomment-341459943
        setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 4000);
    },
    methods: {
        onGeoZoneSearch(search, loading) {
            this.searchGeoZone(search, loading, this);
        },
        searchGeoZone: _.debounce((search, loading, vm) => {
            loading(true);
            vm.provider.search({query: search}).then(res => {
                vm.geoZones = res;
            });
            loading(false);
        }, 500),
        onGeoZoneInput() {
            if (_.isEmpty(this.geoZone)) {
                return;
            }
            let lat = parseFloat(this.geoZone.raw.lat);
            let lng = parseFloat(this.geoZone.raw.lon);
            this.markerLatLng.lat = this.form.lat = this.center.lat = lat;
            this.markerLatLng.lng = this.form.lng = this.center.lng = lng;
            this.form.address = this.geoZone.label;
        },
        getLocations() {
            this.$api.get('locations.all')
                .then(res => {
                    this.locations = res.data
                })
                .finally(() => {
                    this.isLoading = false;
                })
        },
        getStation() {
            this.$api.get('stations.show', this.id)
                .then(res => {
                    this.form.setData(res.data);
                    if (this.form.lat) {
                        this.center = {
                            lat: parseFloat(this.form.lat),
                            lng: parseFloat(this.form.lng)
                        };
                        this.markerLatLng = this.center;
                    }
                })
        },
        save(redirect) {
            if (this.id) {
                this.update(redirect);
            } else {
                this.create(redirect);
            }
        },
        create(redirect) {
            this.form.post('stations.create')
                .then(res => {
                    if (!res.errors) {
                        if (redirect) {
                            this.$router.push({name: 'stations'});
                        } else {
                            this.$router.push('/stations/update/' + res.data.id);
                        }
                        this.$store.commit('successNotify');
                    }
                })
        },
        update(redirect) {
            this.form.put('stations.update', this.id)
                .then(res => {
                    if (!res.errors) {
                        if (redirect) {
                            this.$router.push({name: 'stations'});
                        } else {
                            this.$router.push('/stations/update/' + res.data.id);
                        }
                        this.$store.commit('successNotify')();
                    }
                })
        },
        moveMarker(event) {
            this.markerLatLng = event.latlng;
            this.form.lat = this.markerLatLng.lat;
            this.form.lng = this.markerLatLng.lng;
        },
        zoomUpdated(zoom) {
            this.zoom = zoom;
        },
        centerUpdated(center) {
            this.center = center;
        },
        boundsUpdated(bounds) {
            this.bounds = bounds;
        }
    },
    beforeRouteUpdate(to, from, next) {
        let id = to.params.id;
        if (id) {
            this.id = id;
            this.getStation();
        }
        next();
    }
}
